import * as Immutable from "immutable";
import { PageUIData } from "./pageUIData";

export class SelectorPageUIData extends PageUIData  {
   selectedAssortments: Immutable.List<number>;
}